import { find, get } from "lodash";

export const getAnswerIdByValue = ({ questionOptions, answer }) =>
  get(
    find(questionOptions, {
      option: answer
    }),
    "id"
  );

export const getAnswerValueById = ({ questionOptions, id }) =>
  get(
    find(questionOptions, {
      id
    }),
    "option"
  );
